import { useState } from 'react';
import Card from 'components/card';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';
import { CardFees } from 'views/admin/CardFees';
import { FeeRulesPanel } from 'views/admin/InvoicePaymentConfig/components/FeeRulesPanel';
import { ContractFeesPanel } from './components/ContractFeesPanel';
import { SwapFeePanel } from './components/SwapFeePanel';

const TABS = [
  { key: 'crypto', label: 'Deposit / Withdrawal' },
  { key: 'swap', label: 'Swap' },
  { key: 'cards', label: 'Cards' },
  { key: 'invoice', label: 'Invoice Payments' },
] as const;

type TTabKey = (typeof TABS)[number]['key'];

/**
 * Fees hub (Fees Amendment): every product fee in one place. Crypto and swap
 * fees are new editors; the Cards tab reuses the CardFees editor; the Invoice
 * tab surfaces the invoice fee matrix (also on the Invoice Config page).
 */
export const Fees = () => {
  const [tab, setTab] = useState<TTabKey>('crypto');

  return (
    <ReadPermissionGate
      resource={PERMISSION_RESOURCES.FEES}
      fallback={
        <div className="mt-5 text-center text-gray-600 dark:text-white">
          You don&apos;t have access to Fees Management.
        </div>
      }
    >
      <div className="mt-3">
        <Card extra="p-4">
          <div className="mb-4 flex flex-wrap gap-2">
            {TABS.map(item => (
              <button
                key={item.key}
                onClick={() => setTab(item.key)}
                className={`rounded px-3 py-2 text-sm font-medium ${
                  tab === item.key
                    ? 'bg-brand-500 text-white'
                    : 'border border-gray-200 text-navy-700 dark:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          {tab === 'crypto' && <ContractFeesPanel />}
          {tab === 'swap' && <SwapFeePanel />}
          {tab === 'cards' && <CardFees />}
          {tab === 'invoice' && (
            <ReadPermissionGate
              resource={PERMISSION_RESOURCES.INVOICE_CONFIG}
              fallback={
                <div className="py-4 text-center text-sm text-gray-500">
                  You don&apos;t have access to the invoice fee matrix.
                </div>
              }
            >
              <FeeRulesPanel />
            </ReadPermissionGate>
          )}
        </Card>
      </div>
    </ReadPermissionGate>
  );
};

export default Fees;
